import React from 'react';

type Props = {
  fillColor?: string,
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#fff',
};

const AddIcon = function AddIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4.7194H7.33333V0H4.66667V4.7194H0V7.4162H4.66667V12.1356H7.33333V7.4162H12V4.7194Z" fill={fillColor} />
    </svg>

  );
};
AddIcon.defaultProps = defaultProps;
export default AddIcon;